import * as actionTypes from "./actionTypes";
import * as apiCall from "../services/api";
import { API_BASE_URL } from "../config/apiConfig";


export const checkAnswerSuccess = (data) => {
  return {
    type: actionTypes.CHECK_ANSWER,
    payload: {
      checkAnswer: data.Data,
    },
  };
};

export const checkAnswer = (data) => async (dispatch) => {
  return await apiCall
    .axiosPost(`${API_BASE_URL}/CheckAnswerForMockTest`, data)
    .then((response) => {
      if (response) {
        dispatch(checkAnswerSuccess(response.data));
      }
    })
    .catch((error) => {
      console.log('Error: ', error);
    });
};
